// extracted by mini-css-extract-plugin
export default {"becomeRealtorForm":"style_becomeRealtorForm__d3Ix5","errorText":"style_errorText__symOD"};